import React, { useEffect, useState } from 'react';
import { List, ListItem } from '../../../../Components/List';
import IconBtn from '../../../../Components/IconBtn';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import SpinnerWheel from '../../../../Components/SpinnerWheel';
import {useRankingContext} from '../../Ranking/context/RankingContextProvider';
import { ProductRequestResult } from '../../../../Services/SearchProductFeedTypes';

interface Product {
	id: string;
	name: string;
	urlThumbnail: string;
}

interface ElementToMap {
	idOld: string[];
	idReplace: string[];
	params: { value: { stringValues: string[] } }[];
}


interface SwapListProps {
	elementToMap: ElementToMap[];
	searchTerm: string;
	deleteProduct: (id: string) => void;
	searchProductsByIds: (ids: string[], callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void
}

export const SwapList: React.FC<SwapListProps> = ({
	searchTerm,
	searchProductsByIds,
	deleteProduct,
}) => {
	const {
		setNeedToLoadSwap,
		needToLoadSwap,
		localArrayOfProductIdSwap,
		setIsSwapList
	} = useRankingContext();

	const [filteredItems, setFilteredItems] = useState<Product[]>([]);
	const [items, setItems] = useState<Product[]>([]);
	const [elementsFiltered, setElementsFiltered] = useState<JSX.Element>(<></>);
	const [swapIsLoading, setSwapIsLoading] = useState(true);

	useEffect(() => {
		setIsSwapList(true);
		const timer = setTimeout(() => {
			if (localArrayOfProductIdSwap && localArrayOfProductIdSwap.length > 0 ) {

				const productIds = localArrayOfProductIdSwap.flatMap((item) =>
					item.params.flatMap((param) => param.value.stringValues)
				);
				getArrayOfProducts(productIds);
			}
		}, 800);
		return () => clearTimeout(timer);
	}, [localArrayOfProductIdSwap, needToLoadSwap]);

	useEffect(() => {
		if (searchTerm.length > 0) {
			const searchTermUpper = searchTerm.trim().toUpperCase();
			const filteredItems = items.filter(item =>
				item.name.toUpperCase().includes(searchTermUpper) ||
				item.id.toUpperCase().includes(searchTermUpper)
			);
			setFilteredItems(filteredItems);
		} else {
			setFilteredItems(items);
		}
	}, [searchTerm, items]);

	useEffect(() => {
		const mapElement = filteredItems.map(x => x.id);
		setElementsFiltered(
			<List>
				{localArrayOfProductIdSwap
					.filter(
						(product) =>
							(product.idOld && mapElement.includes(product.idOld[0])) ||
							(product.idReplace && mapElement.includes(product.idReplace[0]))
					)
					.map((product,idx) => {
						const idOld = product.idOld?.[0] || product.isOld?.[0];
						const idReplace = product.idReplace?.[0];

						const oldProduct = idOld ? items.find((p) => p.id === idOld) : null;
						const productReplace = idReplace ? items.find((p) => p.id === idReplace) : null;

						if (!oldProduct || !productReplace) {
							console.log('Product not found for IDs:', idOld, idReplace);
							return null;
						}

						return (
							<ListItem
								key={idx}
								actions={
									<IconBtn
										icon="fas fa-trash"
										tooltip="Remove"
										onClick={() => deleteProduct(idOld || idReplace)}
										hoverColor="alert"
									/>
								}
							>
								<div className='flex'>
									<div className='flex_item_half flex'>
										<div className='flex_item_fix'>
											<ProductThumb
												url={oldProduct.urlThumbnail}
												alt={oldProduct.name}
												width={50}
											/>
										</div>
										<div className='flex_item_full'>
											<div className='s_14'>{oldProduct.name}</div>
											<div className='s_13 grey_3'>{oldProduct.id}</div>
										</div>
									</div>
									<div className='flex_item_fix ml_15 mr_15'>
										<i className="fas fa-exchange-alt grey_3"></i>
									</div>
									<div className='flex_item_half flex'>
										<div className='flex_item_fix'>
											<ProductThumb
												url={productReplace.urlThumbnail}
												alt={productReplace.name}
												width={50}
											/>
										</div>
										<div className='flex_item_full'>
											<div className='s_14'>{productReplace.name}</div>
											<div className='s_13 grey_3'>{productReplace.id}</div>
										</div>
									</div>
								</div>
							</ListItem>
						);
					})

				}
			</List>
		);
	}, [filteredItems, localArrayOfProductIdSwap,items]);

	const getArrayOfProducts = (array: string[]) => {
		setSwapIsLoading(true);
		const callback = (data: ProductRequestResult) => {
			if (data && data.products) {
				const updatedProducts = array
					.map((id) => {
						const product = data.products.find((p) => p.id === id);
						return product
							? { id: product.id, name: product.name, urlThumbnail: product.urlThumbnail }
							: null;
					})
					.filter((product): product is Product => product !== null);
				setItems(updatedProducts);
				setSwapIsLoading(false);
				setNeedToLoadSwap(false);
			} else {
				setSwapIsLoading(false);
				setNeedToLoadSwap(false);
				console.error('No products found in the response');
			}
		};

		searchProductsByIds(array, callback);
	};

	return (
		<>
			{swapIsLoading && <SpinnerWheel wheelSize="l" />}
			{filteredItems.length > 0 && (
				<>
					{elementsFiltered}
				</>
			)}
		</>
	);
};
